import { GetVisitByIdStatusEnum } from 'woofwoof-api';

// #769: only a visit in progress or completed takes a Sale; one that has not
// started, or never took place (#716), takes none. The backend refuses it too.
const VISIT_STATUSES_WITH_SALE: GetVisitByIdStatusEnum[] = [
  GetVisitByIdStatusEnum.Pending,
  GetVisitByIdStatusEnum.Completed,
];

export const isVisitSellable = (
  status: GetVisitByIdStatusEnum | undefined | null,
): boolean => !!status && VISIT_STATUSES_WITH_SALE.includes(status);
